const sizes: Array<number> = [];
let _baseUrls: baseUrls = {
    cdnAssetImages: '',
    cdnProductImages: '',
};

export function addSize(width: number) {
    sizes.push(width);
}

export function setBaseUrls(baseUrls: baseUrls) {
    _baseUrls = baseUrls;
}

function getBaseUrls() {
    return _baseUrls;
}

function getSizes() {
    return sizes.length ? sizes.sort((sizeA, sizeB) => sizeA - sizeB) : [320, 640, 1024, 1600];
}

export default {
    getSizes,
    getBaseUrls,
};

interface baseUrls {
    cdnProductImages: string;
    cdnAssetImages: string;
}
